import React, { Component } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Home from '../views/Home';

class Router extends Component {
    render() {
        return (
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/:link" element={<Home />} />
                </Routes>
            </BrowserRouter>
        );
    }
}

export default Router;
